import styled from 'styled-components';
import { color as colors } from '@workboard/wobo-ui';
export const ReadOnly = styled.div`
  align-items: center;
  width: 380px;
  white-space: normal;

  img {
    width: 40px;
    height: 40px;
    margin-right: 8px;
    border-radius: 100%;
    cursor:inherit;
  }

  h3 {
    margin: 0;
    color: ${colors('#333943')};
    font-family: Lato, Helvetica Neue, sans-serif;
    font-size:22px;
    font-weight: 700;
    float: left;
    width: 90%;
    letter-spacing: .5px;
    padding-top: 4px;
  }
  
  p {
    font-family: Lato, Helvetica Neue, sans-serif;
    font-size: 15px;
    font-weight: 400;
    color: ${colors('#333943')};
    letter-spacing: 0.25px;
    margin: 8px 0px 8px 0px;
  }
  
  div {
    display: inline-block;
	  width: 100%;
    color: ${colors('--gray-600')};
    font-size: 12px;
  }
  p {
    color: #848484
  }
`;
